import React from "react";
import * as Scrivito from "scrivito";
import { create, useModal } from "@ebay/nice-modal-react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

export const ProductImageModal = create(({ image }) => {
  const modal = useModal();

  return (
    <Modal
      isOpen={modal.visible}
      centered={true}
      toggle={modal.hide}
      scrollable={true}
      size="xl"
    >
      <ModalHeader toggle={modal.hide} tag="div" className="pb-0" />
      <ModalBody
        className="d-flex justify-content-center align-items-center m-0 pt-2_5"
        style={{ height: "68vh" }}
      >
        <Scrivito.ImageTag className="img-fluid" content={image} />
      </ModalBody>
    </Modal>
  );
});
